import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/fund.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm fund [<package-spec>]
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/fund.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`This command retrieves information on how to fund the dependencies of a
given project. If no package name is provided, it will list all
dependencies that are looking for funding in a tree structure, listing
the type of funding and the url to visit. If a package name is provided
then it tries to open its funding url using the `}<inlineCode parentName="p">{`--browser`}</inlineCode>{` config
param; if there are multiple funding sources for the package, the user
will be instructed to pass the `}<inlineCode parentName="p">{`--which`}</inlineCode>{` option to disambiguate.`}</p>
    <p>{`The list will avoid duplicated entries and will stack all packages that
share the same url as a single entry. Thus, the list does not have the
same shape of the output from `}<inlineCode parentName="p">{`npm ls`}</inlineCode>{`.`}</p>
    <h4>{`Example`}</h4>
    <h3>{`Workspaces support`}</h3>
    <p>{`It's possible to filter the results to only include a single workspace
and its dependencies using the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config option.`}</p>
    <h4>{`Example:`}</h4>
    <p>{`Here's an example running `}<inlineCode parentName="p">{`npm fund`}</inlineCode>{` in a project with a configured
workspace `}<inlineCode parentName="p">{`a`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm fund
test-workspaces-fund@1.0.0
+-- https://example.com/a
| | \`-- a@1.0.0
| \`-- https://example.com/maintainer
|     \`-- foo@1.0.0
+-- https://example.com/npmcli-funding
|   \`-- @npmcli/test-funding
\`-- https://example.com/org
    \`-- bar@2.0.0
`}</code></pre>
    <p>{`And here is an example of the expected result when filtering only by a
specific workspace `}<inlineCode parentName="p">{`a`}</inlineCode>{` in the same project:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm fund -w a
test-workspaces-fund@1.0.0
\`-- https://example.com/a
  | \`-- a@1.0.0
  \`-- https://example.com/maintainer
      \`-- foo@2.0.0
`}</code></pre>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`json`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Whether or not to output JSON data, rather than the normal output.`}</p>
    <ul>
      <li parentName="ul">{`In `}<inlineCode parentName="li">{`npm pkg set`}</inlineCode>{` it enables parsing set values with JSON.parse() before
saving them to your `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`Not supported by all npm commands.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`browser`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: OS X: `}<inlineCode parentName="li">{`"open"`}</inlineCode>{`, Windows: `}<inlineCode parentName="li">{`"start"`}</inlineCode>{`, Others: `}<inlineCode parentName="li">{`"xdg-open"`}</inlineCode></li>
      <li parentName="ul">{`Type: null, Boolean, or String`}</li>
    </ul>
    <p>{`The browser that is called by npm commands to open websites.`}</p>
    <p>{`Set to `}<inlineCode parentName="p">{`false`}</inlineCode>{` to suppress browser behavior and instead print urls to
terminal.`}</p>
    <p>{`Set to `}<inlineCode parentName="p">{`true`}</inlineCode>{` to use default system URL opener.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`unicode`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false on windows, true on mac/unix systems with a unicode locale,
as defined by the `}<inlineCode parentName="li">{`LC_ALL`}</inlineCode>{`, `}<inlineCode parentName="li">{`LC_CTYPE`}</inlineCode>{`, or `}<inlineCode parentName="li">{`LANG`}</inlineCode>{` environment variables.`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When set to true, npm uses unicode characters in the tree output. When
false, it uses ascii characters instead of unicode glyphs.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`which`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Number`}</li>
    </ul>
    <p>{`If there are multiple funding sources, which 1-indexed source URL to open.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h2>{`See Also`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/package-spec"
        }}>{`package spec`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-docs"
        }}>{`npm docs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-ls"
        }}>{`npm ls`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/workspaces"
        }}>{`npm workspaces`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      